<template lang="pug">
.empty-jobs-table.d-flex.flex-column.align-items-center
  img.mb-30.mt-60(
    :src="emptyIllustration"
    alt="No jobs here."
  )
  p No jobs here.

  slot
</template>

<script>
import { EMPTY_FOLDER_ILLUSTRATION } from '~/rails_assets';

export default {
  name: 'WorkOrdersnoJobsData',
  computed: {
    emptyIllustration() {
      return EMPTY_FOLDER_ILLUSTRATION;
    },
  },
};
</script>
